/**
 * Det de tre oppsettsflatene deler.
 *
 * Samme topp og samme svar når flata ikke er din. At de ser like ut er ikke
 * pynt: de er én ting delt i tre felt, og tre ulike topper ville sagt at de
 * var tre ting.
 */
export function Topp({
  tittel, under,
}: {
  readonly tittel: string;
  readonly under: string;
}): JSX.Element {
  return (
    <header className="oppsett__topp">
      <div>
        <h1 className="oppsett__tittel">{tittel}</h1>
        <p className="oppsett__under">{under}</p>
      </div>
    </header>
  );
}

/**
 * Når flata ikke er din.
 *
 * Den sier HVEM som gjør det, ikke bare at du ikke kan. En flate som bare
 * nekter etterlater folk med et spørsmål de må stille noen andre.
 */
export function IkkeDin(): JSX.Element {
  return (
    <div className="flate flate--oppsett">
      <div className="flate__innhold">
        <div className="loggkort">
          <p className="tomtekst">Ingenting å sette opp for deg her.</p>
          <p className="merknad">
            Prodleder og produsent setter opp produksjonen, redaktøren fører
            deltakerne, og teknikeren setter takten. Du leser alt i
            produksjonen uansett — rollen styrer skriving og oppsett, aldri
            lesing.
          </p>
        </div>
      </div>
    </div>
  );
}
